import { RangePillButton } from 'ui-kit';

import { BaseFiltersConfig, RangeFilter, RangeFilterConfigEntry } from '../filters.types';

import type { CommonProps } from '../PillFilters';

export function RangePillFilter<T extends BaseFiltersConfig>({
  rangeFilter,
  filterConfig,
  removeFilter,
  updateFilter,
  index,
  className = '',
}: CommonProps<T> & {
  rangeFilter: RangeFilter<T>;
  filterConfig: RangeFilterConfigEntry;
  className?: string;
}) {
  return (
    <RangePillButton
      name={filterConfig.displayName}
      min={filterConfig.min}
      max={filterConfig.max}
      displayFormat={filterConfig.displayFormat}
      inputFormat={filterConfig.inputFormat}
      initialValue={[rangeFilter.min, rangeFilter.max]}
      iconName="pill-close"
      onIconClick={() => removeFilter(rangeFilter.name, index)}
      onChange={(values) => updateFilter(rangeFilter.name, index, values)}
      displayPercentage={!!filterConfig.percentage}
      integer={!!filterConfig.integer}
      decimal={!!filterConfig.decimal}
      className={className}
    />
  );
}
